/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

SVG games!

Inpiration: https://websitebeaver.com/how-to-make-an-interactive-and-responsive-svg-map-of-us-states-capitals

*/

$(function(){

    // map
    var interactive_map_selector = '#interactive-map';
    var $interactive_map = $(interactive_map_selector);
    // map classes/selectors
    var interactive_map_group_ignore_id = '';
    var interactive_map_group_data_attr = 'data-group-id';
    var interactive_map_group_class = 'map-group';
    var interactive_map_group_selector = '.map-group';
    var interactive_map_active_group_class = interactive_map_group_class+'--active';
    var interactive_map_active_group_selector = '.'+interactive_map_active_group_class;
    var interactive_map_hover_group_class = interactive_map_group_class+'--hover';
    var interactive_map_hover_group_selector = '.'+interactive_map_hover_group_class;
    // modal classes/selectors
    var interactive_map_modal_class = 'interactive-map-modal';
    var interactive_map_modal_selector = '.'+interactive_map_modal_class;
    var interactive_map_modal_active_class = interactive_map_modal_class+'--active';
    var interactive_map_modal_link_close_selector = interactive_map_modal_selector + '__link-close';
    // nav classes/selectors
    var interactive_map_nav_link_class = 'interactive-map-nav__link';
    var interactive_map_nav_link_selector = '.'+interactive_map_nav_link_class;
    var interactive_map_nav_link_active_class = interactive_map_nav_link_class+'--active';
    var interactive_map_nav_link_hover_class = interactive_map_nav_link_class+'--hover';
    // remember last active group_id
    var last_trigger_group_id = '';

    function resetActiveMapGroup(group_id=0) {
        var selector = 'g[id]';
        if (group_id !== 0) {
            selector = 'g[id="' + group_id + '"]';
        }
        $interactive_map.find(selector).removeClass(interactive_map_active_group_class);
    }

    function setActiveMapGroup(group_id, group_id_array) {
        let selector = '';
        if( group_id_array && group_id_array.length > 0) {
            for (var i = group_id_array.length - 1; i >= 0; i--) {
                selector = 'g[id="' + group_id_array[i].trim() + '"]';
                $interactive_map.find(selector).addClass(interactive_map_active_group_class);
            }
        }else {
            let selector = 'g[id="' + group_id + '"]';
            $interactive_map.find(selector).addClass(interactive_map_active_group_class);
        }

    }

    function resetHoverMapGroup(group_id=0) {
        var selector = 'g[id]';
        if (group_id !== 0) {
            selector = 'g[id="' + group_id + '"]';
        }
        $interactive_map.find(selector).removeClass(interactive_map_hover_group_class);
    }

    function setHoverMapGroup(group_id, group_id_array) {
        let selector = '';
        if( group_id_array && group_id_array.length > 0) {
            for (var i = group_id_array.length - 1; i >= 0; i--) {
                selector = 'g[id="' + group_id_array[i].trim() + '"]';
                $interactive_map.find(selector).addClass(interactive_map_hover_group_class);
            }
        }else {
            selector += 'g[id="' + group_id + '"]';
            $interactive_map.find(selector).addClass(interactive_map_hover_group_class);
        }
    }

    function resetActiveNavItem() {
        $(interactive_map_nav_link_selector).removeClass(interactive_map_nav_link_active_class);
    }

    function resetHoverNavItem() {
        $(interactive_map_nav_link_selector).removeClass(interactive_map_nav_link_hover_class);
    }

    function setHoverNavItem(group_id) {
        // select item that STARTS with the given group_id
        let selector = interactive_map_nav_link_selector+'[' + interactive_map_group_data_attr + '^="' + group_id + '"]';
        $(selector).addClass(interactive_map_nav_link_hover_class);
    }

    function setActiveNavItem(group_id) {
        // select item that STARTS with the given group_id
        let selector = interactive_map_nav_link_selector+'[' + interactive_map_group_data_attr + '^="' + group_id + '"]';
        $(selector).addClass(interactive_map_nav_link_active_class);
    }

    function isSpecificGroupModalVisible(group_id) {
        let selector = interactive_map_modal_selector+'['+interactive_map_group_data_attr+'="'+group_id+'"]';
        if( $(selector).hasClass(interactive_map_modal_active_class) ){
            return true;
        }else {
            return false;
        }
    }

    function isGroupModalVisible() {
        if( $(interactive_map_active_group_selector).length > 0 ){
            return true;
        }else {
            return false;
        }
    }

    function showMapModal(e, group_id) {
        let selector = interactive_map_modal_selector+'['+interactive_map_group_data_attr+'^="'+group_id+'"]';
        $(selector).addClass(interactive_map_modal_active_class);

        var is_human_click = (e.originalEvent !== undefined);
        var link = $(".interactive-map-nav__list-item a[data-default-modal-content-container-id='map-group-detail-" + group_id + "']");

        if (is_human_click || (link.length && !link.hasClass("interactive-map-nav__link--active") && last_trigger_group_id !== group_id)) {
            last_trigger_group_id = group_id;
            link.click();
        }

        last_trigger_group_id = group_id;
    }

    function hideMapModal() {
        $(interactive_map_modal_selector).removeClass(interactive_map_modal_active_class);
    }

    function getMapGroupCoordinates(group_id) {
        let selector = interactive_map_group_selector+'[' + interactive_map_group_data_attr + '="' + group_id + '"]';
        let position = $interactive_map.find(selector).position();
        return position;
    }

    function handleGroupToggle($group_item, nav_context=false) {
        var group_id = 0;
        var group_id_array = null;
        // in navigation context
        if (nav_context) {
            group_id = $group_item.attr(interactive_map_group_data_attr);
        }else {
            group_id = $group_item.attr('id');
        }
        // multiple values
        if (group_id.indexOf(',') !== -1) {
            group_id_array = group_id.split(',');
            // set the first item as default for the navigation
            group_id = group_id_array[0].trim();
        }
        // listen for hover event event
        $group_item.hover(
            function(){
                // modal of this specific group is visible, or we're hovering an unassigned group
                if (isSpecificGroupModalVisible(group_id) || $(this).attr('id') === interactive_map_group_ignore_id ) {
                    // dont't do anything
                }else {
                    // only reset active map groups if NO modal is opened
                    if (!isGroupModalVisible()) {
                        // reset hover styles
                        resetHoverMapGroup();
                    }
                    // set active group
                    setHoverMapGroup(group_id, group_id_array);
                    // set nav item hover
                    setHoverNavItem(group_id);
                }

            },
            function(){
                if (isSpecificGroupModalVisible(group_id)) {
                    // dont' do anything
                }
                else if (isGroupModalVisible()) {
                    // set this groups to INactive
                    resetHoverMapGroup(group_id);
                }
                // reset hover styles
                resetHoverMapGroup();
                // set all nav items to default
                resetHoverNavItem();
            }
        );
        // listen for click event
        $group_item.click(function(e){
            e.preventDefault();
            // hide opened modal
            hideMapModal();
            // show modal
            showMapModal(e, group_id);
            // set all groups to INactive
            resetActiveMapGroup();
            // set active class on map group
            setActiveMapGroup(group_id, group_id_array);
            // reset active nav item
            resetActiveNavItem();
            // set active nav item
            setActiveNavItem(group_id);
        });
    }

    // click on the map closes modal
    // IMPORTANT: Has to be the first 'click' event listener
    $interactive_map.on( 'click', function(e){
        // dont' do anything when clicked on a map group
        if ($(e.target).parents('g[id]').length > 0) {
            // blub
        }else {
            // hide opened modal
            hideMapModal();
            // set all groups to INactive
            resetActiveMapGroup();
            // reset active nav item
            resetActiveNavItem();
        }
    });

    // click on modal doesn't do anything
    $(interactive_map_modal_selector).on( 'click', function(e){
        e.stopPropagation();
    });

    // loop through map groups and assign click event listeners
    $interactive_map.find('g[id]').each(function(){
        handleGroupToggle($(this));
    });

    // loop through navigation and assign click event listeners
    $(interactive_map_nav_link_selector).each(function(){
        let nav_context = true;
        handleGroupToggle($(this),nav_context);
    });

    // close icon of modals
    $(interactive_map_modal_link_close_selector).on('click',function(e){
        e.preventDefault();
        // hide opened modal
        hideMapModal();
        // set all groups to INactive
        resetActiveMapGroup();
        // reset active nav item
        resetActiveNavItem();
    });

    // close modal when hitting ESC
    $(document).keydown(function(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = evt.key == "Escape";
        } else {
            isEscape = evt.keyCode == 27;
        }
        if (isEscape) {
            // only close modal if tingle is not active
            if ($('html').hasClass('default-modal-visible') === false) {
                // hide opened modal
                hideMapModal();
                // set all groups to INactive
                resetActiveMapGroup();
                // reset active nav item
                resetActiveNavItem();
            }
        }
    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Mobile specific

    */

    var interactive_map_mobile_class = 'interactive-map-mobile';
    var interactive_map_mobile_selector = '.'+interactive_map_mobile_class;
    var interactive_map_mobile_heading_link_class = interactive_map_mobile_class+'__heading-link';
    var interactive_map_mobile_heading_link_selector = '.'+interactive_map_mobile_heading_link_class;
    var interactive_map_mobile_nav_visible_class = 'mobile-nav-visible';
    var interactive_map_mobile_content_visible_class = 'mobile-content-visible';
    // nav
    var interactive_map_mobile_nav_class = 'interactive-map-mobile-nav';
    var interactive_map_mobile_nav_selector = '.'+interactive_map_mobile_nav_class;
    var interactive_map_mobile_nav_link_class = interactive_map_mobile_nav_class+'__link';
    var interactive_map_mobile_nav_link_selector = '.'+interactive_map_mobile_nav_link_class;
    var interactive_map_mobile_list_class = interactive_map_mobile_class+'__list';
    var interactive_map_mobile_nav_item_class = interactive_map_mobile_content_class+'__list-item';
    // content
    var interactive_map_mobile_content_class = 'interactive-map-mobile-content';
    var interactive_map_mobile_content_list_item_class = interactive_map_mobile_content_class+'__list-item';
    var interactive_map_mobile_content_list_item_selector = '.'+interactive_map_mobile_content_list_item_class;
    var interactive_map_mobile_content_list_item_active_class = interactive_map_mobile_content_list_item_class+'--active';
    var interactive_map_mobile_content_close_link_class = interactive_map_mobile_content_class+'__link-close';
    var interactive_map_mobile_content_close_link_selector = '.'+interactive_map_mobile_content_close_link_class;
    var interactive_map_mobile_content_back_link_class = interactive_map_mobile_content_class+'__link-back';
    var interactive_map_mobile_content_back_link_selector = '.'+interactive_map_mobile_content_back_link_class;

    // back to location list
    $(interactive_map_mobile_content_back_link_selector).on('click',function(e){
        // init
        e.preventDefault();
        // remove container classes
        $(interactive_map_mobile_selector).
            removeClass(interactive_map_mobile_content_visible_class);
        // remove active list item classes
        $(interactive_map_mobile_content_list_item_selector).removeClass(interactive_map_mobile_content_list_item_active_class);
    });

    // close location
    $(interactive_map_mobile_content_close_link_selector).on('click',function(e){
        // init
        e.preventDefault();
        // remove container classes
        $(interactive_map_mobile_selector).
            removeClass(interactive_map_mobile_nav_visible_class).
            removeClass(interactive_map_mobile_content_visible_class);
        // remove active list item classes
        $(interactive_map_mobile_content_list_item_selector).removeClass(interactive_map_mobile_content_list_item_active_class);
    });

    // toggle location list
    $(interactive_map_mobile_heading_link_selector).on('click',function(e){
        // init
        e.preventDefault();
        // toggle class
        $(interactive_map_mobile_selector).toggleClass(interactive_map_mobile_nav_visible_class);
    });

    // open location
    $(interactive_map_mobile_nav_link_selector).on('click',function(e){
        // init
        e.preventDefault();
        window.scrollTo(0, 0); // jump to top to avoid scrolling back
        var $list_item = $(this);
        var group_id = $list_item.attr(interactive_map_group_data_attr);
        // prepare selector
        let selector = interactive_map_mobile_content_list_item_selector+'['+interactive_map_group_data_attr+'="'+group_id+'"]';
        // add active class
        $(selector).addClass(interactive_map_mobile_content_list_item_active_class);
        // toggle class on container
        $(interactive_map_mobile_selector).addClass(interactive_map_mobile_content_visible_class);
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/interactive-map.js